<div class="flex flex-col w-full h-full">
  <h1 class="mb-8 text-light-300 text-3xl font-medium">
    Page Under Construction
  </h1>

  <div class="flex flex-row w-full h-full items-center justify-center">
    <img
      src="assets/images/seedio-under-construction.webp"
      class="rounded-3xl w-[60%] max-w-xl shadow-md"
    />
  </div>
</div>
